import {AbstractError} from "./AbstractError";

export class HttpError extends AbstractError {}
export class BadRequestError extends HttpError {}
export class UnauthorizedError extends HttpError {}
export class ForbiddenError extends HttpError {}
export class NotFoundError extends HttpError {}
export class InternalServerError extends HttpError {}